import { css } from "@emotion/css";
import React from "react";
import {
  Header as AriaHeader,
  Section as AriaSection,
} from "react-aria-components";

import { Text } from "../../../foundations/typography/Text";

interface MenuSectionProps {
  children: (React.ReactElement | false)[] | React.ReactElement;
  title?: string;
  testID?: string;
}

export function MenuSection(props: MenuSectionProps) {
  const { children, title, testID = "menu-section" } = props;

  return (
    <AriaSection className={styles.actionArea} data-testid={testID}>
      <AriaHeader className={styles.header}>
        {title && (
          <div className={styles.sectionHeaderContainer}>
            <Text style="input/label" className={styles.sectionHeader}>
              {title}
            </Text>
          </div>
        )}
      </AriaHeader>

      {children}
    </AriaSection>
  );
}

const styles = {
  header: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-1)",
  }),
  sectionHeaderContainer: css({
    paddingBottom: "var(--space-1)",
  }),
  sectionHeader: css({
    padding: `${"var(--space-05)"} ${"var(--space-4)"}`,
    display: "inline-block",
  }),

  actionArea: css({
    paddingBottom: "var(--space-1)",
    gap: "var(--space-1)",
    display: "flex",
    flexDirection: "column",
  }),
};
